import CouponManage from '@/views/CouponManage.vue'
import { createRouter, createWebHashHistory } from 'vue-router'

// 直接导入组件，避免懒加载问题
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import Vehicle from '@/views/Vehicle.vue'
import Order from '@/views/Order.vue'
import Coupon from '@/views/Coupon.vue'
import CouponCreate2 from '@/views/CouponCreate2.vue'
import CouponQr from '@/views/CouponQr.vue'
import Profile from '@/views/Profile.vue'
import Recharge from '@/views/Recharge.vue'
import TransferInfo from '@/views/TransferInfo.vue'
import AccountDetail from '@/views/AccountDetail.vue'
import InvoiceUnissued from '@/views/InvoiceUnissued.vue'
import InvoiceIssue from '@/views/InvoiceIssue.vue'
import InvoiceTitle from '@/views/InvoiceTitle.vue'
import InvoiceIssued from '@/views/InvoiceIssued.vue'
import Settings from '@/views/Settings.vue'
import UserProfile from '@/views/UserProfile.vue'
import ChangePassword from '@/views/ChangePassword.vue'
import BindPhone from '@/views/BindPhone.vue'
import VehicleAdd from '@/views/VehicleAdd.vue'
import VehicleInvite from '@/views/VehicleInvite.vue'

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  { path: '/home', component: Home },
  { path: '/order', component: Order },
  { path: '/vehicle', component: Vehicle },
  { path: '/vehicle/add', component: VehicleAdd },
  { path: '/vehicle/invite', component: VehicleInvite },
  { path: '/coupon', component: Coupon },
  { path: '/coupon/manage', component: CouponManage },
  { path: '/coupon/create2', component: CouponCreate2 },
  { path: '/coupon/qr', component: CouponQr },
  { path: '/profile', component: Profile },
  { path: '/recharge', component: Recharge },
  { path: '/transfer', component: TransferInfo },
  { path: '/account', component: AccountDetail },
  { path: '/invoice/unissued', component: InvoiceUnissued },
  { path: '/invoice/issue', component: InvoiceIssue },
  { path: '/invoice/title', component: InvoiceTitle },
  { path: '/invoice/issued', component: InvoiceIssued },
  { path: '/settings', component: Settings },
  { path: '/user-profile', component: UserProfile },
  { path: '/change-password', component: ChangePassword },
  { path: '/bind-phone', component: BindPhone }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
